require('../../modules/es.set');
require('../../modules/esnext.set.some');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Set', 'some');
